module.exports = __webpack_public_path__ + "static/media/612EchoStNW_2018-06-25_192.ad134a2b.jpg";